import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMobile } from '../../../hooks/useMobile';

import { ROUTE_PATH } from '../../../route/utils';

import Cart from './Cart';

import Navigation from '../../navigation/Navigation';

const CartPage = () => {
  const isMobile = useMobile();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMobile) {
      navigate(ROUTE_PATH.MENU, { replace: true });
    }
  }, [isMobile, navigate]);

  if (!isMobile) return null;

  return (
    <Navigation>
      <Cart />
    </Navigation>
  );
};

export default CartPage;
